export default [
  {
    name: 'text',
    component_path: 'modules/templates/blocks/TemplateText'
  }
]